import { MiaPlaza } from "@/Reinforced.Typings";
import { VNode } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { registerModule } from "vuex-simple";
import MiaTourModule from "./MiaTourModule";

/**
 * This Vue component is responsible for registering the `MiaTourModule` in the Vuex store.
 * It initializes the module with mia tour data, member-specific tour progress, and 
 * a first-login flag passed as props. Ensures the module is registered only once.
 */
@Component
export default class MiaTourModuleRegistration extends Vue {
	@Prop({ required: true, type: Object }) protected tours!: Record<MiaPlaza.Model.MiaTour.Tour, MiaPlaza.LO.MiaTours.IMiaTour>;
	@Prop({ required: true, type: Array }) protected memberTours!: MiaPlaza.Model.MiaTour.Tour[];
	@Prop({ required: true, type: Boolean }) protected firstLogin!: boolean;

	protected created(): void {
		this.registerMiaToursModule();
	}

	private registerMiaToursModule() {
		if (!this.$store.hasModule(MiaPlaza.Control.Vue.MiaTourModuleRegistration.MODULE)) {
			registerModule(this.$store, [MiaPlaza.Control.Vue.MiaTourModuleRegistration.MODULE],
				new MiaTourModule(this.tours, this.memberTours, this.firstLogin));
		}
	}

	/** 
	 * A render function is required when a Vue component lacks a `<template>`. 
	 * Since this is a logical component with no rendered DOM elements, we return `undefined` 
	 * to prevent errors or warnings. 
	 */
	protected render(): VNode[] | undefined {
		return undefined;
	}
}
